/* RPL — products come into focus.
 *
 * Driven by the Web Animations API rather than a CSS hidden-state, on purpose.
 * The previous approach set opacity:0 in CSS and depended on script to undo
 * it; when that failed the storefront showed nothing. Here the element's
 * resting state is always the visible one and the animation plays FROM a
 * hidden keyframe, so every failure mode — no JS, blocked script, an engine
 * that ignores the observer — degrades to "the products are simply there".
 *
 * Three things happen at once and end at different times, which is what
 * separates a considered entrance from a fade:
 *   FOCUS   a 7px blur resolving to sharp — the camera finding the garment
 *   DEPTH   a real perspective tilt, the card lying back 7deg and standing up
 *   SETTLE  38px of rise with a 4% scale, decelerating hard at the end
 */
(function () {
  if (!document.body || !document.body.animate) return;            // no WAAPI: leave it alone
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var OUTER = '.grid__item, .collection-list__item';
  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  function targets() {
    var out = [].slice.call(document.querySelectorAll(OUTER));
    // A product must animate exactly once: Dawn nests .card-wrapper inside
    // .grid__item, and animating both compounds the scale and multiplies the
    // opacity into mud.
    [].slice.call(document.querySelectorAll('.card-wrapper')).forEach(function (el) {
      if (!el.closest(OUTER)) out.push(el);
    });
    return out.filter(function (el) { return !el.dataset.rplDone; });
  }

  function play(el, step) {
    el.dataset.rplDone = '1';
    var delay = Math.min(step, 8) * 80;
    el.animate([
      { opacity: 0,
        transform: 'perspective(1400px) translate3d(0,38px,-90px) rotateX(7deg) scale(0.96)',
        filter: 'blur(7px)' },
      // Blur clears early so the garment is legible while the card is still
      // easing into place; ending everything on one frame reads mechanical.
      { opacity: 1, filter: 'blur(0px)', offset: 0.55 },
      { opacity: 1,
        transform: 'perspective(1400px) translate3d(0,0,0) rotateX(0deg) scale(1)',
        filter: 'blur(0px)' }
    ], { duration: 1350, delay: delay, easing: EASE, fill: 'backwards' });

    // The image pushes in fractionally behind the card — a slow breath that
    // outlives the entrance by a beat instead of stopping dead.
    var img = el.querySelector('.card__media img');
    if (img) img.animate(
      [{ transform: 'scale(1.055)' }, { transform: 'scale(1)' }],
      { duration: 1700, delay: delay, easing: EASE, fill: 'backwards' });
  }

  function sweep() {
    var vh = window.innerHeight || 800;
    var batch = [];
    targets().forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      // A screen and a half, so a quick scroll never outruns the entrance.
      if (top < vh * 1.5) batch.push({ el: el, top: top });
      else if (io) io.observe(el);
      else batch.push({ el: el, top: top });
    });
    batch.sort(function (a, b) { return a.top - b.top; });
    batch.forEach(function (o, i) { play(o.el, i); });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    var landing = entries.filter(function (e) { return e.isIntersecting; });
    landing.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
    landing.forEach(function (e, i) { io.unobserve(e.target); play(e.target, i); });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }) : null;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
  window.addEventListener('load', sweep);
  // Dawn replaces the grid in place on filter/sort; new cards need the same.
  new MutationObserver(sweep).observe(document.body, { childList: true, subtree: true });
})();
